import React, { useContext, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from "react-router";
import { Row, Col, Card, CardBody, Button, InputGroup, CustomInput, CardHeader } from 'reactstrap';
import { Route, Switch } from 'react-router-dom';
import NavbarTop from '../../../navbar/NavbarTop';
import NavbarVertical from '../../../navbar/NavbarVertical';
import Footer from '../../../footer/Footer';
import loadable from '@loadable/component';
import AppContext from '../../../../context/Context';
import { useAuthState } from '../../../../context';
import { MenuTypeProvider } from '../../../../context/MenuTypeContext';
import SidePanelModal from '../../../side-panel/SidePanelModal';
import { getPageName } from '../../../../helpers/utils';
import MenuTypeBar from '../../../menu-type-bar';
import { logout } from '../../../../actions/authAction';
import Settings from './../settings';


const Dashboard = loadable(() => import('./dashboard'));
const Manage = loadable(() => import('../manage'));
const Reports = loadable(() => import('../reports'));
const Recipes = loadable(() => import('../manage/recipes'));
const Home = ({ location }) => {
  const { isFluid, isVertical, navbarStyle } = useContext(AppContext);
  const { authInfo, otherInfo } = useAuthState();
  const isKanban = getPageName('kanban');
  // Inactive schools should not show up in the All Schools dropdown.
  const activeSchools = useMemo(() => ((otherInfo || {}).schools || []).filter(sch => sch.isActive !== false), [otherInfo]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const onNavbarTopItemClick = (action) => {
    switch (action) {
      case 'LOGOUT':
        logout();
        window.location.replace('/login');
        break;
      default:
        break
    }
    return false;
  };
  return (
    <div className={isFluid || isKanban ? 'container-fluid pl-1 pr-1' : 'container'}>
      {isVertical && <NavbarVertical isKanban={isKanban} navbarStyle={navbarStyle} />}

      <div className="content">
        <NavbarTop onRightSideNavItemClick={onNavbarTopItemClick} />
        <Card className="mb-3 shadow-none" style={{ minHeight: '90vh' }}>
          <MenuTypeProvider>
            <CardBody className="bg-100 p-0" >
              <CardHeader className='p-1'>
                <MenuTypeBar schoolList={activeSchools} authInfo={authInfo} />
              </CardHeader>
              <Switch>
                <Route path="/dashboard" exact component={Dashboard} />
                <Route path="/manage" component={Manage} />
                <Route path="/reports" component={Reports} />
                <Route path="/recipes" component={Recipes} />
                <Route path="/settings" component={Settings} />
                <Route path="/" component={Dashboard} />
              </Switch>
            </CardBody>
          </MenuTypeProvider>
        </Card>
        {!isKanban && <Footer />}
      </div>
      {/* <SidePanelModal path={location.pathname} /> */}

    </div>
  );

}
Home.propTypes = { location: PropTypes.object.isRequired };
export default withRouter(Home);